/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Utilita pro přípravu na zobrazení HTML iframe elementů,
 * která neprovádí žádné operace.
 * Používá se, když není žádoucí provádět preflight
 * (spamování webů dotazy, unit testy, ...).
 * @implements {HtmlIframePreflighter}
 */
class HtmlIframePreflighterNoop {
  /** @inheritdoc */
  preflight(url) {
    return Promise.resolve();
  }
}

export default HtmlIframePreflighterNoop;
